const ULTRAWIDE_ASPECT = 2.2;
const ULTRAWIDE_SCALE = 2;
const ULTRAWIDE_MIN_WIDTH = 1600;
const ULTRAWIDE_MIN_HEIGHT = 720;

/** Desktop-ultrawide world zoom. Kept independent of Pixi so responsive behavior
 *  can be verified without constructing WebGPU in a test environment. */
export function worldScaleForViewport(width: number, height: number): number {
  if (width < ULTRAWIDE_MIN_WIDTH || height < ULTRAWIDE_MIN_HEIGHT) return 1;
  const aspect = width / Math.max(1, height);
  return aspect >= ULTRAWIDE_ASPECT ? ULTRAWIDE_SCALE : 1;
}
